import { gql } from '@apollo/client';

export const GET_AVAILABLE_DRIVERS_BY_WAREHOUSE_ID = gql`
  query GetAvailableDriversByWarehouseId($warehouseId: Long!, $dspId: Long) {
    getAvailableDriversByWarehouseId(warehouseId: $warehouseId, dspId: $dspId) {
      id
      accountId
      name
      phone
      driverLicenseNumber
      vehiclePlate
      isBlacklist
      isOnDuty
      dspId
      verificationStatus
      status
      isEmployed
      __typename
    }
  }
`;
